<!--
 * @Author: taowuhua
 * @: 
 * @Date: 2024-11-18 14:37:33
 * @LastEditors: taowuhua
 * @LastEditTime: 2024-11-18 17:28:46
 * @Description: file content
-->
<template>
  <div class="login-container">
    <div class="title">请绑定手机号</div>
    <div class="title">欢迎来到三泾庙</div>
    <van-form @submit="handleLogin">
      <van-field v-model="loginForm.phone"
                 label="手机号"
                 placeholder="请输入手机号"
                 type="tel"
                 required
                 :rules="[{ required: true, message: '请输入手机号' }]" />
      <van-field v-model="loginForm.verificationCode"
                 label="验证码"
                 placeholder="请输入验证码"
                 type="text"
                 required
                 :rules="[{ required: true, message: '请输入验证码' }]"
                 v-slot:button>
        <van-button size="small"
                    type="primary"
                    @click="getVerificationCode"
                    :disabled="codeBtnDisabled">
          {{ codeBtnText }}
        </van-button>
      </van-field>
      <div style="margin-top: 16px;">
        <van-button round
                    block
                    type="info"
                    native-type="submit">登录</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginForm: {
        phone: '',
        verificationCode: '',
      },
      codeBtnText: '获取验证码',
      codeBtnDisabled: false,
    };
  },
  methods: {
    handleLogin() {
      // 此处添加登录逻辑，例如表单验证或API调用
      console.log('登录信息：', this.loginForm);
      this.$http.post("https://www.shcnsyg.com/tempt/api/sjte/register", {
          "code": this.loginForm.verificationCode,
          "openid": localStorage.getItem("openid"),
          "phone": this.loginForm.phone
      })
        .then((response) => {
          console.log(JSON.stringify(response), "登录")
          localStorage.setItem("token", response.result?.token);
          this.$router.push("/")
        })
    },
    getVerificationCode() {
      // 此处添加获取验证码的逻辑，例如发送API请求
      this.startCodeCountdown();
      this.$http.get("https://www.shcnsyg.com/tempt/api/sjte/getSendCode", {
        params: {
          "openid": localStorage.getItem("openid"),
          "phone": this.loginForm.phone
        }
      })
        .then((response) => {
          console.log(JSON.stringify(response), "验证码")
        })
    },
    startCodeCountdown() {
      let countdown = 60;
      this.codeBtnDisabled = true;
      this.codeBtnText = `${countdown}秒后重新获取`;

      const timer = setInterval(() => {
        countdown--;
        if (countdown > 0) {
          this.codeBtnText = `${countdown}秒后重新获取`;
        } else {
          clearInterval(timer);
          this.codeBtnText = '获取验证码';
          this.codeBtnDisabled = false;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.login-container {
  max-width: 320px;
  margin: 100px auto;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #fff;
}
</style>


